export default __webpack_public_path__ + "static/media/photo-charte07.b2871c43.png";